import serverCall from '../serverCall';

const login = async (body: any) => {
  try {
    const response = await serverCall.post('/investors/login', body);
    return response;
  } catch (error) {
    throw error;
  }
}

const register = async (body: any) => {
  try {
    const response = await serverCall.post('/investors', body);
    return response;
  } catch (error) {
    throw error;
  }
};

const getInvestorProfile = async (id: string) => {
  try {
    const response = await serverCall.get(`/investors/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getContactNo = async (country: string) => {
  try {
    const response = await serverCall.get('/contactno', { params: country ? { country } : {} });
    return response;
  } catch (error) {
    throw error;
  }
};

const getPresences = async () => {
  try {
    const response = await serverCall.get('/presences/countries');
    return response;
  } catch (error) {
    throw error;
  }
};

const forgotPassword = async (body: any) => {
  try {
    const response = await serverCall.post('/investors/forgot-password', body);
    return response;
  } catch (error) {
    throw error;
  }
};

const Monetileservice = {
  login,
  register,
  getInvestorProfile,
  getContactNo,
  getPresences,
  forgotPassword,
};

export default Monetileservice;